"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "Runtime", {
  enumerable: true,
  get: function get() {
    return _runtime.Runtime;
  }
});
Object.defineProperty(exports, "Feature", {
  enumerable: true,
  get: function get() {
    return _runtime.Feature;
  }
});
Object.defineProperty(exports, "Helper", {
  enumerable: true,
  get: function get() {
    return _runtime.Helper;
  }
});
exports["default"] = void 0;

require("@babel/polyfill/noConflict");

var _runtime = require("./runtime");
/**
 * @type {Runtime}
 */


var runtime = (0, _runtime.createSingleton)();
var _default = runtime;
exports["default"] = _default;